const styles = () => ({
    avatar: {
        margin: '0 .5em 0 1em',
    },
    popoverContent: {
        backgroundColor: '#515558',
    },
    user: {
        padding: '.5em 1em',
        borderBottom: '1px solid #313131',
    },
    userText: {
        color: 'white',
    },
    listItemText: {
        color: 'white',
        fontSize: '.9rem',
    },
    listItemIcon: {
        color: 'white',
    },
    langSelector: {
        color: 'white',
        padding: '.5em 1em',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    flag: {
        width: '2rem',
        cursor: 'pointer',
        opacity: 0.5,
        '&:hover, &.active': {
            opacity: 1,
        },
    },
    label: {
        fontSize: '.9rem',
    },
});

export default styles;
